import axios from "axios";
import {
  BillsAndBalancesResponse,
  MadingResponse,
  ReportBalancesResponse,
} from "./dtos/home.dto";
import { BaseService } from "./base.service";
import { BaseResponseExternal } from "./dtos/base.dto";

interface HomeServiceInterface {
  queries: {
    GET_BILLS_AND_BALANCES: string;
    GET_DATA_REPORT_BALANCES: string;
    GET_MADING: string;
  };
  billsAndBalances(payload: { nis: string }): Promise<BillsAndBalancesResponse>;
  reportBalances(payload: {
    nis: string;
    limit: string;
  }): Promise<ReportBalancesResponse>;
  mading(kategori: string, limit: string): Promise<MadingResponse>;
}
export const HomeService: HomeServiceInterface = {
  queries: {
    GET_BILLS_AND_BALANCES: "GET_BILLS_AND_BALANCES",
    GET_DATA_REPORT_BALANCES: "GET_DATA_REPORT_BALANCES",
    GET_MADING: "GET_MADING",
  },
  billsAndBalances: async (payload: { nis: string }) => {
    try {
      // const request = await BaseService.request().get<BillsAndBalancesResponse>(
      //   "/home/bills-and-balances"
      // );
      // localStorage.setItem("nis", request.data.data?.nis ?? "");
      // return BaseService.response(request);
      const request = await axios.get<BillsAndBalancesResponse>(
        `https://sipiatapiot.sipond.id/api/tagihan/bill-and-balance`,
        {
          params: payload,
          headers: {
            token:
              "$2y$12$.ztMaYznNLvwXEBgQ6G.TunKw/ONAj9uTnCmBdsnnDXOkzikQxxBG",
          },
        }
      );
      return {
        success: request.data.success,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  reportBalances: async (payload: { nis: string; limit: string }) => {
    try {
      const request = await axios.get<ReportBalancesResponse>(
        `https://sipiatapiot.sipond.id/api/keuangan/laporan-uang-saku`,
        {
          params: payload,
          headers: {
            token:
              "$2y$12$.ztMaYznNLvwXEBgQ6G.TunKw/ONAj9uTnCmBdsnnDXOkzikQxxBG",
          },
        }
      );
      return {
        success: request.data.success,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  mading: async (kategori: string, limit: string) => {
    try {
      const request = await axios.get<BaseResponseExternal>(
        `https://sipiatapiot.sipond.id/api/admin/mading-slider/${kategori}/${limit}`,
        {
          headers: {
            token:
              "$2y$12$.ztMaYznNLvwXEBgQ6G.TunKw/ONAj9uTnCmBdsnnDXOkzikQxxBG",
          },
        }
      );
      return {
        success: request.data.status,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      throw new Error(error.message);
    }
  },
};
